import React from "react"
import {KlassDropdown, KlassDropdownProps} from "../Select"
import {TERM_BILLING_METHOD_OPTIONS} from "types/students"

type Props = Partial<KlassDropdownProps> & {}

export const BillingMethodSelect: React.FC<Props> = ({...props}) => {
    return <KlassDropdown {...props} options={TERM_BILLING_METHOD_OPTIONS} />
}
